import { Button } from 'tamagui';
export default (() => <Button id="circular" circular />);